export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angebote"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meine Geschäfte"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meine Anzeigen"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geschäfte"])}
}